import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { Icon, PortalDropdownMenu, ShowIf } from '@ztechapps/webui.util'
import { ComposerModeEnum, useConversationContext } from './Context'
import styles from './ComposerModeToggle.module.scss'

// The reply-mode switch in the editor header. The Internal note item is not listed while the
// mount has no conversation — a note is stored on the conversation, so there is nothing to attach
// it to yet; the toggle itself is always on screen.
export const ComposerModeToggle = () => {
  const { conversationId, composerMode, setComposerMode } = useConversationContext()
  const isPublicMode = composerMode === ComposerModeEnum.Public

  return (
    <Dropdown>
      <Dropdown.Toggle variant="link" className={`fw-semibold ${styles.composerModeToggle}`}>
        <span aria-hidden="true" className="me-1">
          <Icon name={isPublicMode ? 'reply' : 'lock'} />
        </span>
        {composerMode}
      </Dropdown.Toggle>
      {/* Portalled so the menu drops clear of the editor header instead of clipping inside it — Bootstrap's own
          dropdown layer already clears the flyout panel and the title band, so no z-index is written here. */}
      <PortalDropdownMenu>
        <Dropdown.Item active={isPublicMode} onClick={() => setComposerMode(ComposerModeEnum.Public)}>
          <span aria-hidden="true" className="me-1">
            <Icon name="reply" />
          </span>
          {ComposerModeEnum.Public}
        </Dropdown.Item>
        <ShowIf condition={!!conversationId}>
          <Dropdown.Item active={!isPublicMode} onClick={() => setComposerMode(ComposerModeEnum.Note)}>
            <span aria-hidden="true" className="me-1">
              <Icon name="lock" />
            </span>
            {ComposerModeEnum.Note}
          </Dropdown.Item>
        </ShowIf>
      </PortalDropdownMenu>
    </Dropdown>
  )
}
